/**
 * @file src/pages/invoice-creation-wizard/useIssueInvoice.js
 * @description React Query mutation hook for issuing an invoice to ZATCA.
 *
 * What changed:
 *  - Import from utils/invoiceApis → api/invoice.api.js
 *  - console.log/error removed
 *  - On success, invoice-side and dashboard query sources are invalidated
 *  - Callers handle feedback via toast
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { issueInvoice } from "api/invoice.api";
import {
  invalidateDashboardSources,
  invalidateInvoiceSide,
} from "lib/cacheInvalidation";

export const useIssueInvoice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invoiceId) => issueInvoice(invoiceId),
    onSuccess: () => {
      invalidateInvoiceSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
